module.exports = __webpack_public_path__ + "img/bobinas_y_solenoides.973fb746.jpg";